module.exports = __webpack_public_path__ + "7a6a72289462959f95e500b97e0979d8.png";